import { resolveMemberAvatarUrl } from '@/utils/member-avatar';
import { resolveIssueTypeIconUrl } from '@/utils/issue-type-icon';

/** Множество URL, которые уже были предзагружены — не дублируем запросы. */
const preloaded = new Set<string>();

/**
 * Предзагружает изображения аватаров и иконок типов задач для списка каналов.
 * Вызывать после получения данных от `listChannels()` — браузер закэширует картинки,
 * и при рендере `<img>` они отобразятся мгновенно.
 */
export function preloadChannelImages(
  channels: readonly Record<string, unknown>[],
): void {
  const urls: string[] = [];

  for (const ch of channels) {
    // Аватар собеседника в DM
    const avatar = ch.dm_other_avatar;
    if (typeof avatar === 'string') {
      const url = resolveMemberAvatarUrl(avatar);
      if (url) urls.push(url);
    }

    // Иконка типа задачи (issue channel)
    const icon = ch.issue_type_icon;
    if (typeof icon === 'string') {
      const url = resolveIssueTypeIconUrl(icon);
      if (url) urls.push(url);
    }
  }

  for (const url of urls) {
    if (preloaded.has(url)) continue;
    preloaded.add(url);
    const img = new Image();
    img.src = url;
  }
}
